import { useAppSelector } from 'features';
import { selectDownloadList, selectIsGeneratingFile } from 'features/Downloads';

import DownloadItem from './DownloaderItem';
import GeneratingFile from './GeneratingFile';

const DownloaderList = () => {
  const downloadList = useAppSelector(selectDownloadList);
  const isGeneratingFile = useAppSelector(selectIsGeneratingFile);

  const sortedFiles = downloadList?.sort((a, b) => {
    if (a.status === 'downloading' && b.status !== 'downloading') return -1;
    if (a.status !== 'downloading' && b.status === 'downloading') return 1;
    return 0;
  });

  return (
    <ul
      className="downloader-list"
      style={{
        overflowY: downloadList?.length > 4 ? 'scroll' : 'hidden',
        maxHeight: downloadList?.length > 4 ? 200 : 'auto',
      }}
    >
      {isGeneratingFile && <GeneratingFile />}

      {sortedFiles?.map((file) => (
        <DownloadItem key={`${file.id}-${file.name}`} file={file} />
      ))}
    </ul>
  );
};

export default DownloaderList;
